import Right from "@/models/Right";

export default class StagedRight extends Right {
  get claimStartDate() {
    if (Number(this.FDAT) === 0) {
      return '0000-00-00';
    }
    return super.claimStartDate;
  }

  get hasError() {
    return Boolean(Number(this.errflg));
  }
}